<template>
  <div class="allbox">
    <div class="top_inrwe">
      <div class="condition">
        <el-input
          v-model="query.email"
          class="inptw"
          placeholder="请输入匹配邮箱"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getList"
        >查询</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="insert"
        >新增</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="copy_que_data.list"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="email"
        label="邮箱"
      />
      <el-table-column
        prop="distributor_id"
        label="distributor_id"
      />
      <el-table-column
        prop="secret_key"
        label="secret_key"
      />
      <el-table-column
        prop="num"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="delAccount(scope.row)">删除</el-button>
          <el-button type="primary" size="mini" @click="editAccount(scope.row)">编辑</el-button>
          <el-button type="success" size="mini" @click="lookApp(scope.row)">查看小程序</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="copy_que_data.total"
      @size-change="fetchpageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="edit_query.id? '编辑': '新增'"
      :visible.sync="copy_visible"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="distributor_id">
          <el-input
            v-model="edit_query.distributor_id"
            style="width: 300px;margin-left: 5px"
            placeholder="请输入distributor_id"
          />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input
            v-model="edit_query.email"
            style="width: 300px;margin-left: 5px"
            placeholder="请输入邮箱"
          />
        </el-form-item>
        <el-form-item label="secret_key">
          <el-input
            v-model="edit_query.secret_key"
            style="width: 300px;margin-left: 5px"
            placeholder="请输入secret_key"
          />
        </el-form-item>
      </el-form>
      <div style="margin-top: 10px">
        <el-button
          type="success"
          @click="addCopy"
        >确定</el-button>
        <el-button
          type="info"
          @click="copy_visible = false"
        >取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看小程序"
      :visible.sync="look_app_visible"
    >
      <el-table
        :data="app_data.list"
        highlight-current-row
        border
        style="width: 100%"
      >
        <el-table-column
          prop="app_id"
          label="小程序id"
        />
        <el-table-column
          prop="tt_id"
          label="抖音id"
        />
        <el-table-column
          prop="wx_app_id"
          label="微信app_id"
        />
        <el-table-column
          prop="app_name"
          label="小程序名称"
        />
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editApp(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :current-page="look_app_query.page"
        :total="app_data.total"
        @size-change="appFetchpageSize"
        @current-change="appFetchCurrentPage"
      />
      <el-dialog
        :visible.sync="edit_app_visible"
        title="编辑小程序"
        width="500px"
        :append-to-body="true"
      >
        <el-form label-width="100px">
          <el-form-item label="微信app_id">
            <el-input
              v-model="edit_app.wx_app_id"
              style="width: 300px;margin-left: 5px"
              placeholder="请输入微信app_id"
            />
          </el-form-item>
          <el-form-item label="抖音id">
            <el-input
              v-model="edit_app.tt_id"
              style="width: 300px;margin-left: 5px"
              placeholder="请输入抖音id"
            />
          </el-form-item>
        </el-form>
        <div style="margin-top: 10px">
          <el-button
            type="success"
            @click="commitAppEdit"
          >确定</el-button>
          <el-button
            type="info"
            @click="edit_app_visible = false"
          >取消</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  changduAccountList,
  changduAccountAdd,
  changduAccountDel, changduAccountEdit, lookAppList, EditApp
} from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      copy_que_data: {
        list: null,
        total: 0
      },
      app_data: {
        list: null,
        total: 0
      },
      query: {
        page: 1,
        page_size: 10,
        email: null
      },
      copy_visible: false,
      loading: false,
      edit_query: {
        secret_key: null,
        distributor_id: null,
        email: null
      },
      look_app_visible: null,
      look_app_query: {
        page: 1,
        page_size: 10,
        id: null
      },
      edit_app_visible: false,
      edit_app: {
        id: null,
        wx_app_id: null,
        tt_id: null
      }
    }
  },
  computed: {},
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      changduAccountList(this.query).then(res => {
        this.copy_que_data = res.data
        this.loading = false
        console.log(res)
      })
    },
    fetchpageSize(e) {
      this.query.page_size = e
      this.getList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getList()
    },
    appFetchpageSize(e) {
      this.look_app_query.page_size = e
      this.getAppList()
    },
    appFetchCurrentPage(e) {
      this.look_app_query.page = e
      this.getAppList()
    },
    insert() {
      this.copy_visible = true
      this.edit_query = {
        email: null,
        distributor_id: null,
        secret_key: null
      }
    },
    addCopy() {
      if (this.edit_query.id) {
        console.log('编辑')
        changduAccountEdit(this.edit_query).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message.success(res.message)
            this.getList()
            this.copy_visible = false
            this.edit_query.email = null
            this.edit_query.secret_key = null
            this.edit_query.distributor_id = null
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        changduAccountAdd(this.edit_query).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message.success(res.message)
            this.getList()
            this.copy_visible = false
            this.edit_query.email = null
            this.edit_query.secret_key = null
            this.edit_query.distributor_id = null
          } else {
            this.$message.error(res.message)
          }
        })
        console.log('添加')
      }
    },
    getAppList() {
      lookAppList(this.look_app_query).then(res => {
        this.app_data = res.data.data
      })
    },
    lookApp(val) {
      console.log(val)
      this.look_app_query.id = val.id
      this.getAppList()
      this.look_app_visible = true
    },
    delAccount(val) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changduAccountDel({ id: val.id }).then(res => {
          if (res.code === 0) {
            this.$message.success('删除成功')
          }
        })
      })
    },
    editAccount(val) {
      this.copy_visible = true
      this.edit_query.id = val.id
      this.edit_query.email = val.email
      this.edit_query.secret_key = val.secret_key
      this.edit_query.distributor_id = val.distributor_id
    },
    editApp(val) {
      console.log(val)
      this.edit_app_visible = true
      this.edit_app.id = val.id
      this.edit_app.tt_id = val.tt_id
      this.edit_app.wx_app_id = val.wx_app_id
    },
    commitAppEdit() {
      EditApp(this.edit_app).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success('编辑成功')
          this.edit_app_visible = false
          this.getAppList()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.allbox {
  padding: 30px;
}

.top_inrwe {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inptw {
  width: 250px;
}

.condition > * {
  margin-right: 10px;
}
</style>
